import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import { stripeAPI } from '../api/services/stripe'
import { useAuth } from '../context/auth'
import { isUserExistsInGroup } from '../utils/userRights.ts'
import { usePanelUserRights } from './usePanelUserRights.ts'

const useStripeAccountInfo = () => {
  const { state } = useAuth()
  const { hasUserRights } = usePanelUserRights()
  const isRestrictedUser = (state.groups && state.groups?.length > 0)
    ? isUserExistsInGroup(
    state.groups,
    'dd_panel_restricted_users'
  )
    : true

  const [stripeAccountCompleted, setStripeAccountCompleted] =
    useState<boolean>(false)

  const fetchData = async () => {
    try {
      const response = !isRestrictedUser && hasUserRights
        ? await stripeAPI.getStripeData()
        : {
            data: {
              is_main: false,
              onboarding_completed: false,
              stripe_account: false,
              requirements_filled: true
            },
          status: 'success',
          error: null
          }
      return response.data
    } catch (error) {
      console.error(error)
    }
  }

  const { data, status } = useQuery({
    queryKey: ['stripeAccountInfo', state.email],
    queryFn: fetchData
  })

  if (status === 'success' && data?.onboarding_completed === true) {
    !stripeAccountCompleted && setStripeAccountCompleted(true)
  }

  return { data, status, stripeAccountCompleted }
}

export default useStripeAccountInfo
